type Config = {
  environment: string;
  sentryDsn: string;
  debug?: boolean;
  apiBaseUrl: string;
  wsBaseUrl: string;
  cloudfrontRoot: string;
  landingRoot: string;
  googleMapsApiKey: string;
  posthog: {
    publicKey: string;
    publicHost: string;
  };
  amplifyCognitoConfig: {
    loginWith: { email: boolean };
    userPoolId: string;
    userPoolClientId: string;
    signUpVerificationMethod: "code";
    passwordFormat: {
      minLength: number;
      requireNumbers: boolean;
      requireLowercase: boolean;
      requireUppercase: boolean;
      requireSpecialCharacters: boolean;
    };
  };
  adminCognitoConfig: {
    userPoolId: string;
    userPoolClientId: string;
    oauthDomain: string;
  };
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
};

type Configs = {
  [key: string]: Config;
};

const DEFAULT_PASSWORD_FORMAT = {
  minLength: 8,
  requireNumbers: true,
  requireLowercase: true,
  requireUppercase: true,
  requireSpecialCharacters: false,
} as const;

const DEFAULT_COGNITO_CONFIG = {
  loginWith: { email: true },
  autoSignIn: true,
  signUpVerificationMethod: "code" as const,
  passwordFormat: DEFAULT_PASSWORD_FORMAT,
} as const;

const posthogConfig = {
  publicKey: "phc_KIPPBSSSGTyIKeP8RSb1Ef0sbt47rKxZSOcmjMyu44d",
  publicHost: "https://eu.i.posthog.com",
} as const;

const alphaConfig = {
  environment: "alpha",
  sentryDsn:
    "https://70058ce4e999f00c84c12be76bf5d6d5@o4509293884145664.ingest.de.sentry.io/4509675331387472",
  apiBaseUrl: "https://y7c19kal13.execute-api.eu-central-1.amazonaws.com/",
  wsBaseUrl: "https://r1xyogb749.execute-api.eu-central-1.amazonaws.com/main",
  cloudfrontRoot: "https://app.alpha.woofapy.com",
  landingRoot: "https://alpha.woofapy.com",
  googleMapsApiKey: "AIzaSyALnTn3lPLLVVrQSEBkUPv2Ibt4PDfBiOI",
  posthog: posthogConfig,
  amplifyCognitoConfig: {
    ...DEFAULT_COGNITO_CONFIG,
    userPoolId: "eu-central-1_3qozW6oj5",
    userPoolClientId: "4nep0jee41rfb82oa806avhtts",
  } as const,
  adminCognitoConfig: {
    userPoolId: "eu-central-1_ENA11iLc5",
    userPoolClientId: "16ujfni6tji8pgv8n5raj93iui",
    oauthDomain:
      "woofapy-admin-276824024392-eu-central-1.auth.eu-central-1.amazoncognito.com",
  },
  firebaseConfig: {
    apiKey: "AIzaSyBFerpxFnTYJhn-1pEMr75TwRwXkCiDssE",
    authDomain: "woofapy-alpha.firebaseapp.com",
    projectId: "woofapy-alpha",
    storageBucket: "woofapy-alpha.firebasestorage.app",
    messagingSenderId: "176086680927",
    appId: "1:176086680927:web:e3c0f9206e5d5a1c0d62ea",
    measurementId: "G-VGP1HB66R9",
  },
};

const allConfigs: Configs = {
  localhost: {
    ...alphaConfig,
    environment: "localhost",
    debug: true,
    landingRoot: "http://localhost:9001",
    apiBaseUrl: "http://localhost:8000",
  },
  "app.alpha.woofapy.com": alphaConfig,
  "app.beta.woofapy.com": {
    environment: "beta",
    sentryDsn: alphaConfig.sentryDsn,
    apiBaseUrl: "https://dav7ndjxii.execute-api.eu-central-1.amazonaws.com/",
    wsBaseUrl: "https://oszkqi2a4k.execute-api.eu-central-1.amazonaws.com/main",
    cloudfrontRoot: "https://app.beta.woofapy.com",
    landingRoot: "https://beta.woofapy.com",
    googleMapsApiKey: "AIzaSyA7V1YNEhZd9mLgLc13zhHZQ8u-LeKgifo",
    posthog: posthogConfig,
    amplifyCognitoConfig: {
      ...DEFAULT_COGNITO_CONFIG,
      userPoolId: "eu-central-1_8f8ZyHsmt",
      userPoolClientId: "1bn3kc1nnpe7e42j8p8kpu1j0o",
    } as const,
    adminCognitoConfig: {
      userPoolId: "eu-central-1_PPg06VIGq",
      userPoolClientId: "12lbc0028hr7gjlq8mc08fub7j",
      oauthDomain:
        "woofapy-admin-048158596681-eu-central-1.auth.eu-central-1.amazoncognito.com",
    },
    firebaseConfig: {
      apiKey: "AIzaSyCoTAsoLmdiyE5sfIUtvG40WpOTFuWO_1I",
      authDomain: "woofapy-beta.firebaseapp.com",
      projectId: "woofapy-beta",
      storageBucket: "woofapy-beta.firebasestorage.app",
      messagingSenderId: "143906459670",
      appId: "1:143906459670:web:6c7d448ccf8e6ec21c2537",
    },
  },
  "app.woofapy.com": {
    environment: "prod",
    sentryDsn: alphaConfig.sentryDsn,
    apiBaseUrl: "https://4van8noo2e.execute-api.eu-central-1.amazonaws.com/",
    wsBaseUrl: "https://82t0en9nvj.execute-api.eu-central-1.amazonaws.com/main",
    cloudfrontRoot: "https://app.woofapy.com",
    landingRoot: "https://woofapy.com",
    googleMapsApiKey: "AIzaSyDt6hPcnLlgFdpBq7wghFbMKR-5PmnjDCM",
    posthog: posthogConfig,
    amplifyCognitoConfig: {
      ...DEFAULT_COGNITO_CONFIG,
      userPoolId: "eu-central-1_0ei2bMASD",
      userPoolClientId: "kj364dt9bk4i7kgf0n0eefp2c",
    } as const,
    adminCognitoConfig: {
      userPoolId: "eu-central-1_F8QSTObeo",
      userPoolClientId: "1uhnn0p3blvjprt5ru52vufjf6",
      oauthDomain:
        "woofapy-admin-304035489461-eu-central-1.auth.eu-central-1.amazoncognito.com",
    },
    firebaseConfig: {
      apiKey: "AIzaSyBRJRrL-NHDDw7X8KdxTHgCbW-ys1yrPUw",
      authDomain: "woofapy-prod.firebaseapp.com",
      projectId: "woofapy-prod",
      storageBucket: "woofapy-prod.firebasestorage.app",
      messagingSenderId: "991998483197",
      appId: "1:991998483197:web:907f29c2c2baf7c187bc94",
    },
  },
};

const getConfig = () => {
  const config = allConfigs[self.location.hostname];
  if (!config) {
    throw new Error(`No config found for ${self.location.hostname}`);
  }
  return config;
};

export const config = getConfig();
